import * as React from 'react';
import './ShippingOptions.scss';
import RadioButton from 'src/components/common/RadioButton';
import Dropdown from 'src/components/common/Dropdown';

export const DROP_OFF_AT_STORE = 'dropOffAtStore';
export const SHIP_TO_DISTRIBUTION = 'shipToDistribution';
export const SAVE_FOR_LATER = 'saveForLater';
export const SUBMIT_NOW = 'submitNow';

interface IShippingOptionsProps {
  shippingSelectedOption: string;
  handleShippingChangeOption: (e: any) => void;
  rmaSelected: string;
  t?: any;
}

const ShippingOptions: React.FC<IShippingOptionsProps> = props => {
  const {
    rmaSelected,
    shippingSelectedOption,
    handleShippingChangeOption,
    t
  } = props;

  const getSelectedOption = () => {
    const options = {
      dropOffAtStore: false,
      shipToDistribution: false
    };

    options[shippingSelectedOption] = true;
    return options;
  };

  const selection = getSelectedOption();

  return (
    <div className="rp-returns-options">
      <div className="rp-returns-options-existing">
        <RadioButton
          name={t('myReturns.dropOffatStore')}
          className="rp-returns-options-radio"
          value={DROP_OFF_AT_STORE}
          checked={selection.dropOffAtStore}
          onChange={handleShippingChangeOption}
        />
      </div>
      <div className="rp-returns-options-new">
        <RadioButton
          name={t('myReturns.shipTodistributionCenter')}
          className="rp-returns-options-radio"
          value={SHIP_TO_DISTRIBUTION}
          checked={selection.shipToDistribution}
          onChange={handleShippingChangeOption}
        />
      </div>
    </div>
  );
};

export default ShippingOptions;
